export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=3faa9ff2&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/stub-event-swiper/index.vue?vue&type=template&id=3faa9ff2&
// module id = 989
// module chunks = 0